const getters = {
  userInfo: state => state.store.userInfo, //登录用户的信息
  rasPublicKey: state => state.store.rasPublicKey, //登录用户的信息
  tabsOn: state => state.store.tabsOn, //快捷访问 选中标签页
  tabsList: state => state.store.tabsList, //快捷访问 标签页列表
  permissionCodes: state => state.store.permissionCodes,
  auditCalendar_queryDate: state => state.store.auditCalendar_queryDate,
  auditCalendar_station: state => state.store.auditCalendar_station,
  ywjl_queryDate: state => state.store.ywjl_queryDate,
  loading: state => state.store.loading,
  drawerTable: state => state.store.drawerTable,
  taskDetail: state => state.store.taskDetail,
  shjdblData: state => state.store.shjdblData,
  zssjData: state => state.store.zssjData,
  dqType: state => state.map.dqType,
  dateTime: state => state.map.dateTime,
  dn: state => state.gis.dn,
  station: state => state.gis.station,
  stationName: state => state.gis.stationName,
  szType: state => state.map.szType,
  pzgl: state => state.store.pzgl,
  nav: state => state.store.nav,
  adminName: state => state.store.adminName,
  YQYD: state => state.store.YQYD,
  addTask: state => state.store.addTask,
  lastTab: state => state.store.lastTab,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js